import {Box, Stack, Typography} from "@mui/material";
import {CustomChip} from "../CustomChip";
import {BackButton} from "../BackButton";
import {ProjectWithPreview} from "../ProjectWithPreview";

const ASC = () => {
    return (
        <ProjectWithPreview projectUrl={"https://www.aventurasicalatorii.ro/"}>
            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 3,
                padding: 3,
                height: '100%',
                justifyContent: 'space-between'
            }}>
                {/* Project Title */}
                <Box sx={{gap: 3, display: 'flex', flexDirection: 'column'}}>
                    <Typography variant="h3" sx={{fontWeight: 600, mb: 1}}>
                        Website for Aventură și Călătorii (travel company)
                    </Typography>
                    <Typography variant="h6" sx={{color: 'text.secondary'}}>
                        Website for presenting the company and the services
                    </Typography>

                    {/* Overview */}
                    <Box>
                        <Typography variant="h5" sx={{color: 'secondary.main', mb: 1, fontWeight: 500}}>
                            Overview
                        </Typography>
                        <Typography variant="body1" sx={{lineHeight: 1.7, whiteSpace: 'pre-line'}}>
                            The website is static and it's made in React with typescript.{'\n'}
                            This site features company description, a team gallery, and the list of available trips
                            to reserve and coaches to rent.{'\n'}
                            The client does not want a server to process trips reservations, because each trip is
                            highly customizable and depends on factors negotiated with each client. A contact form
                            might be added in the future.
                        </Typography>
                    </Box>

                    {/* Tech summary */}
                    <Box>
                        <Typography variant="h5" sx={{color: 'secondary.main', mb: 1.5, fontWeight: 500}}>
                            Technologies
                        </Typography>
                        <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                            <CustomChip text={'React'} variant={'primary'}/>
                        </Stack>
                    </Box>

                    {/* Tools summary */}
                    <Box>
                        <Typography variant="h5" sx={{color: 'secondary.main', mb: 1.5, fontWeight: 500}}>
                            Tools
                        </Typography>
                        <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                            <CustomChip text={'Github'} variant={'secondary'}/>
                            <CustomChip text={'Render.com'} variant={'secondary'}/>
                            <CustomChip text={'HOSTAGE'} variant={'secondary'}/>
                            <CustomChip text={'Zoho Mail'} variant={'secondary'}/>
                            <CustomChip text={'Adobe Photoshop'} variant={'secondary'}/>
                        </Stack>
                    </Box>
                </Box>

                <Box>
                    <BackButton/>
                </Box>
            </Box>
        </ProjectWithPreview>
    )
}

export default ASC;